define('core/utils/urls',[], function () {
    'use strict';
    var exports = {};

    /**
     * Get the origin of the URL.
     *
     * Given a fully-formed or protocol relative URL, extracts an origin value for use with window.postMessage.
     * For example:
     *     `getOrigin('https://example.com:555/index/') -> 'https://example.com:555'`
     *
     * See https://developer.mozilla.org/en-US/docs/Web/API/URLUtils/origin
     * @returns {string}
     */
    var _anchor = window.document.createElement('a');
    exports.getOrigin = function (url) {
        // Use the anchor tag to guarantee a fully formed URL.
        _anchor.href = url;
        var parts = _anchor.href.split('/');
        return parts[0] + '//' + parts[2];
    };

    exports.getHostName = function (url) {
        _anchor.href = url;
        return _anchor.hostname;
    };

    exports.getDomainPart = function (url, level) {
        // Return the domain identifier at `level` for `url`.
        // This method will return the top-level domain by default.
        // Usually we'll be using this with level == 2 to return a
        // forum subdomain if present.

        if (typeof level === 'undefined')
            level = 0;

        var host = exports.getHostName(url);
        var parts = host.split('.').reverse();
        return parts[level];
    };

    exports.getQuery = function (url) {
        _anchor.href = url;
        return _anchor.search;
    };

    exports.getPathname = function (url) {
        _anchor.href = url;
        return _anchor.pathname;
    };

    return exports;
});

